
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { useSearchParams } from "react-router-dom"
import { Loading } from '../../../../../Helper/Loading'
import Header from '../../../../../Components/Header/Header'
import Sidebar from '../../../../../Components/Sidebar/Sidebar'
import { useAuthState } from '../../../../../Helper/Context'
import { Pegination } from '../../../../../Components/Pegination/Pegination'
import DeletePopup from '../../GardenPopup/DeletePopup'
import { WardNameDataDDL } from '../../../../../Components/CommonDDL/WardNameDataDDL'
import { LocationDDL } from '../../../../../Components/CommonDDL/LocationDDL'
import { WorkNameDDL } from '../../../../../Components/CommonDDL/WorkNameDDL'
import WardWiseTokenModal from './Modal/WardWiseTokenModal'
import { WorkTypeDDL } from '../../../../../Components/CommonDDL/WorkTypeDDL'
import { Get_M_ELEC_WardWiseToken_SelectAPI, M_ELEC_WardWiseToken_DeleteAPI } from '../../../../../Redux/WardWiseTokenSlice/WardWiseTokenSlice'
import ViewToken from './Modal/ViewToken'

export const WardWiseToken = () => {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")


    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [showTokenPopup, setshowTokenPopup] = React.useState(false)
    const [DeletePopupShow, setDeletePopupShow] = useState(false)
    const [OpenCount, setOpenCount] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [WorkType, setWorkType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: '0',
        Label: "Select...",
    })

    const [WorkName, setWorkName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })


    const [DesignationPopupShow, setDesignationPopupShow] = useState()

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setDesignationPopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setrowData(item)
        setDesignationPopupShow(true)
        setapiFlag('Update')
    }

    const handleOnCloseClick = () => {
        setDesignationPopupShow(false)
        handleIsPost()
    }

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...',
        })
        setWorkName({
            ...WorkName,
            ID: 0,
            Label: 'Select...',
        })
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    useEffect(() => {
        const data = {
            M_WardID: WardName?.ID,
            token: token,
            M_UserID: UserID,
            Flag: 'Master'
        }
        dispatch(Get_M_ELEC_WardWiseToken_SelectAPI({ data }))
    }, [WardName?.ID])

    const { tableData, isLoading } = useSelector(state => state.Get_M_ELEC_WardWiseToken_SelectData)


    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [Designation.ID])

    const handleDeleteApi = (item) => {

        const data = {
            M_ELEC_WardWiseTokenID: item?.m_eleC_WardWiseTokenID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            handleDeleteCloseClick: handleDeleteCloseClick
        }
        dispatch(M_ELEC_WardWiseToken_DeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.M_ELEC_WardWiseToken_DeleteData)

    const handleDeleteCloseClick = () => {
        setDeletePopupShow(!DeletePopupShow)
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    const handleOpenCount = () => {
        setOpenCount(!OpenCount)
    }

    const handleViewToken = (i) => {
        setrowData(i)
        setshowTokenPopup(!showTokenPopup)
    }

    return (
        <>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                        DashProjectTypeId={DashProjectTypeId}
                        active="pole" listActive="active" />

                    <div id="" className="content1">
                        <div className="data_mob1">
                            <div className="row m-1 py-1 pb-4 master_border">
                                <div>
                                    <h5 className="ps-1 py-1">Ward Wise Token Master</h5>
                                    <div className="col-12 col-lg-7 float-end">
                                        {/* <DesignationPopup
                                            open={DesignationPopupShow}
                                            handleIsPost={handleIsPost}
                                        /> */}
                                        <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                            style={{ color: "white", marginTop: '-2em' }} onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div>
                                <div className="row m-0 ">
                                    <div className="col-12 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12">

                                            <div className="row py-1 rounded2">
                                                {/* <div className="col-12 col-md-4 col-lg-3">
                                                    <WorkTypeDDL
                                                        WorkType={WorkType}
                                                        setWorkType={setWorkType}
                                                        isDisplay={true}
                                                    />
                                                </div> */}
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <WardNameDataDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        HWard='0'
                                                        WLable=''
                                                        Type="Electrical"
                                                        APIFlag="WardWiseToken_Ward"
                                                        IsPost={IsPost}
                                                    />
                                                </div>

                                                <div className="col-12 col-md-3 col-lg-2 mt-4">
                                                    {/* <div className="col-12 col-md-3 col-lg-3 mt-lg-4 mt-md-4 d-md-flex" > */}

                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>
                                            </div>
                                            <div className="row mob_table table-responsive pt-1">

                                                <table
                                                    id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            {/* <th>Work Type</th> */}
                                                            <th>Ward Name</th>
                                                            <th>Token</th>
                                                            <th>Session</th>
                                                            <th>API</th>
                                                            <th>Domain</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData?.table && tableData?.table?.length > 0 ? tableData?.table.map((i, j) =>
                                                                <tr style={{ width: '100%' }}>
                                                                    <td style={{ textAlign: "center" }}>{j + 1}</td>
                                                                    {/* <td>NA</td> */}
                                                                    <td>{i?.wardName}</td>
                                                                    <td style={{ textAlign: 'center' }}>
                                                                        {
                                                                            i?.token ?
                                                                                <i className="fa-solid fa-eye" title='View'
                                                                                    style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                    onClick={() => handleViewToken(i?.token)}
                                                                                ></i>
                                                                                : '-'
                                                                        }
                                                                    </td>
                                                                    <td style={{ textAlign: 'center' }}>{i?.sessionID ? i?.sessionID : '-'}</td>
                                                                    <td style={{ textAlign: 'center' }}>{i?.api}</td>
                                                                    <td style={{ textAlign: 'center' }}>{i?.domainID ? i?.domainID : '-'}</td>
                                                                    <td style={{ textAlign: "center", width: '10%' }}>

                                                                        <span>
                                                                            <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleEditOnClick(i)}
                                                                            >
                                                                            </i>
                                                                        </span>

                                                                        <span>
                                                                            <DeletePopup
                                                                                open={DeletePopupShow}
                                                                                handleDeleteApi={handleDeleteApi}
                                                                                item={i}
                                                                            />
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ) :
                                                                <td colSpan={15}>No data found</td>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {
                    showTokenPopup &&
                    <ViewToken
                        open={showTokenPopup}
                        close={handleViewToken}
                        rowData={rowData}
                        Heading="View Token"
                    />
                }

                {
                    DesignationPopupShow ?
                        <WardWiseTokenModal
                            open={DesignationPopupShow}
                            // popupHeading="Location Name"                         
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                            IsPost={IsPost}
                            setIsPost={setIsPost}
                        />
                        : <></>
                }


            </div>

        </>
    )
}